import { IAjax } from 'lib/ajax';
import { DataCacheCollection } from 'lib/DataCache';
import TZDate from 'lib/TZDate';
import { TZUtils } from 'lib/tzutils';
import { tzmomentMod } from 'lib/tzmoment';
import { Pollster } from 'lib/pollster';

export interface UrlParams {
    NeedSince : string | null
}

export interface LogUpdaterParams<T, Data> {
    collection : DataCacheCollection<T, Data>;
    url : (params : UrlParams) => string;
    refreshSeconds : number;
    refreshBackwardsMins? : number;
}

export type LogUpdater = ReturnType<typeof LogUpdater>;

// Utility for auto-updating the portcalllog component.
// Construct LogUpdater in your parent view and pass it into the portcalllog component.
// NOTE: Important -- please dispose the LogUpdater from your parent view. The portcalllog component does NOT dispose the LogUpdater automatically.
// Rule of thumb - whichever component constructs the LogUpdater should also dispose it.
export function LogUpdater<T, Data>(
    ajax : IAjax,
    tzutils : TZUtils,
    {
        collection,
        url: _url,
        refreshSeconds,
        refreshBackwardsMins
    } : LogUpdaterParams<T, Data>
) {
    let lastUpdated : TZDate | null = null;
    return new Pollster(updateLog, refreshSeconds * 1000);

    function updateLog() {
        // TH: We introduced async change detection to support generating change events from auto-saving text fields.
        // I.e. after a user edits a text field, it might take a few mins (depending on configuration) for that edit to be matierialized into a change Event.
        // But that Event will still have the timestamp of the last edit as its Date field.
        // (Since it seemed more accurate to set the Date to the last edit date rather than the detection date).
        // So we need to reach back several mins when we update the log, otherwise we'll miss those updates.
        const needSince = lastUpdated && tzmomentMod(tzutils, lastUpdated, m => m.subtract(refreshBackwardsMins || 0, 'minutes')),
            url = _url({ NeedSince: needSince && needSince.toJSON() }),
            // TH 02/23/2017 -- Convention. We assume our Log endpoints return an array of Relevances.
            req = ajax.Url<Data[]>(url).Get();
        return req.then(json => {
            const ts = req.Date;
            lastUpdated = tzutils.newDate(+ts);
            collection.update(ts, json, []);
        });
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/eventlog/logupdater.ts